/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Accordion from './accordion.js';

Fancybox.bind('.popup-youtube, .popup-vimeo', {
	backdropClick: false,
	caption: function (fancybox, slide) {
		const transcript = slide.triggerEl?.parentElement.parentElement.querySelector('[data-popup-transcript]');
		return transcript
			? '<details data-details="" data-transcript="" class="group/details relative bg-white transition-all z-20 *:box-border text-primary *:w-full">' +
					transcript.innerHTML +
					'</details>'
			: slide.caption || '';
	},
	on: {
		done: (fancybox) => {
			const contentWidth = fancybox.container.querySelector('iframe').clientWidth;

			fancybox.container.querySelector('.is-close-btn').focus();
			fancybox.container.querySelector('iframe').setAttribute('title', 'Play Video');

			if (fancybox.container.querySelector('.fancybox__caption')) {
				console.log('ee');
				fancybox.container.querySelector('.fancybox__caption').style.width = `${contentWidth}px`;
				const accordion = fancybox.container.querySelector('[data-details]');
				if (accordion) {
					new Accordion(accordion);
				}
			}
		},
	},
});
